import styles from 'Containers/ContactForm/LeadForm/styles.scss';
import { Stepper } from 'Containers/ContactForm/LeadForm/Stepper';
import React from 'react';
import classNames from 'classnames/bind';
import Typography from 'Components/Typography';

const cx = classNames.bind(styles);

const Header = ({ headline, modalType, activeStep, goToStep, validSteps }) => (
  <div className={cx(styles.header)}>
    <Typography.Headline
      additonalProps={{ id: 'modal-redesign-headline' }}
      aria-label={headline}
      forceUppercase={true}
      level="h2"
      value={headline}
    />
    <div>
      {validSteps.length > 1 ? (
        <Stepper
          modalType={modalType}
          activeStep={activeStep}
          setActiveStep={goToStep}
          validSteps={validSteps}
        />
      ) : (
        <>&nbsp;</>
      )}
    </div>
  </div>
);

export { Header };
